import { defaultLocale, translations, type Locale } from "./translations";

export type TranslationParams = Record<string, string | number>;

const templateRegex = /\{(\w+)\}/g;

const formatTemplate = (value: string, params?: TranslationParams) => {
  if (!params) {
    return value;
  }
  return value.replace(templateRegex, (match, key) => {
    const replacement = params[key];
    return replacement === undefined ? match : String(replacement);
  });
};

export const isLocale = (value: string): value is Locale => value === "da" || value === "en";

export const translate = (
  locale: Locale,
  key: string,
  fallback: string,
  params?: TranslationParams,
) => {
  const dictionary = translations[locale] ?? translations[defaultLocale] ?? {};
  const template = dictionary[key] ?? fallback;
  return formatTemplate(template, params);
};
